
import { Mixins, Component, Prop } from 'vue-property-decorator'
import IndividualColorMixin from '../mixins/IndividualColorMixin.vue'

@Component
export default class SvgLinkBtn extends Mixins(IndividualColorMixin) {
  @Prop() svgLinkType!: 'result_report' | 'project_donate' | 'project'
  @Prop() instanceSlug!: string
  @Prop({ type: Number, default: 56 }) width!: number
  @Prop({ type: Number, default: 56 }) height!: number
  @Prop({ type: String, default: null, required: false }) svgTitle!: string | null

  get isPathData (): boolean {
    return /^[MLCQZmlcqz]/.test(this.svgLink.svgPath)
  }

  get svgLink (): { svgPath: string, title: string, text: string, url: string, capsForTitle?: boolean } {
    if (this.svgLinkType === 'result_report') {
      return {
        svgPath: '/static/img/detail-page-thumbs-up.svg',
        title: this.$gettext("Good news"),
        capsForTitle: true,
        text: this.$gettext("News and results"),
        url: `/project/${this.instanceSlug}/public-result-report/`
      }
    } else if (this.svgLinkType === 'project_donate') {
      return {
        svgPath: '/static/img/detail-page-project.svg',
        title: this.$gettext("Support project"),
        capsForTitle: true,
        text: this.$gettext("Support this project with a donation"),
        url: `/project/${this.instanceSlug}/donate`
      }
    } else if (this.svgLinkType === 'project') {
      return {
        svgPath: '/static/img/detail-page-project.svg', // todo ask peter for svg
        title: this.svgTitle, // the title is passed from parent
        capsForTitle: true,
        text: this.$gettext("To the original project"),
        url: `/project/${this.instanceSlug}`
      }
    }
    return {
      svgPath: '',
      title: '',
      capsForTitle: false,
      text: '',
      url: ''
    }
  }
}
